import script from "./Guide.vue?vue&type=script&setup=true&lang=js"
export * from "./Guide.vue?vue&type=script&setup=true&lang=js"

import "./Guide.vue?vue&type=style&index=0&id=8ec9da6e&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ec9da6e"]])

export default __exports__